import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useDummyAcceptVideoCallMutation as useDummyAcceptVideoCallMutationType } from "@/modules/video-call/services/__generated__/useDummyAcceptVideoCallMutation.graphql"

const dummyAcceptVideoCall = graphql`
  mutation useDummyAcceptVideoCallMutation($input: DummyAcceptVideoCallInput!) {
    dummyAcceptVideoCall(input: $input) {
      boolean
    }
  }
`

const useDummyAcceptVideoCallMutation = () => {
  const [commit, isFlight] = useMutation<useDummyAcceptVideoCallMutationType>(dummyAcceptVideoCall)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDummyAcceptVideoCallMutationType>) => {
      commit(config)
    },
    [commit],
  )
  return [commitHandler, isFlight] as const
}

export { useDummyAcceptVideoCallMutation }
